import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { Component } from 'react';
import { isEnabled, toggleVerboseLogging } from './operators/verboseLogging';
import { readClipboardData } from './operators/readClipboardData';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { View } from 'foundations-components/components/View';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LETTER_D = 68;
class DebugOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDebug: false,
      lastEventId: null,
      verboseLoggingEnabled: isEnabled()
    };
    this.toggleVerboseLogging = this.toggleVerboseLogging.bind(this);
    this.debugClipboardContents = this.debugClipboardContents.bind(this);
    this.sendDebugData = this.sendDebugData.bind(this);
    this.closeDebug = this.closeDebug.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  componentDidMount() {
    document.addEventListener('keyup', this.handleKeyUp);
  }
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyUp);
  }
  handleKeyUp(event) {
    const {
      altKey,
      ctrlKey,
      shiftKey,
      keyCode,
      code
    } = event;
    const isLetterD = keyCode === LETTER_D || code === 'KeyD';
    if (altKey && ctrlKey && shiftKey && isLetterD) {
      this.setState({
        showDebug: true
      });
      if (this.props.onEnterDebug) {
        this.props.onEnterDebug();
      }
    }
  }
  closeDebug() {
    this.setState({
      showDebug: false
    });
  }
  toggleVerboseLogging() {
    this.setState(state => {
      return {
        verboseLoggingEnabled: !state.verboseLoggingEnabled
      };
    });
    toggleVerboseLogging();
  }
  debugClipboardContents() {
    readClipboardData().then(clipboardData => {
      // eslint-disable-next-line no-console
      console.log('Clipboard data:', clipboardData);
      Raven.captureMessage(`Debug Clipboard ${Date.now()}`, {
        level: 'info',
        extra: clipboardData
      });
      this.setState({
        lastEventId: Raven.lastEventId()
      });
    }).catch(e => {
      // eslint-disable-next-line no-console
      console.error(`Failed to read the clipboard: ${e}`);
    });
  }
  sendDebugData() {
    Raven.captureMessage(`Debug Data ${Date.now()}`, {
      level: 'info'
    });
    this.setState({
      lastEventId: Raven.lastEventId()
    });
  }
  render() {
    if (!this.state.showDebug) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Modal, {
      size: "auto",
      use: "default",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-error-reporting.debugOverlay.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: this.closeDebug
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [this.props.renderNetworkStatistics ? this.props.renderNetworkStatistics() : null, /*#__PURE__*/_jsxs(View, {
          marginBlockEnd: "400",
          children: [/*#__PURE__*/_jsx(FormLabel, {
            htmlFor: "debug-overlay-verbose-logging",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.enableLogs"
            })
          }), /*#__PURE__*/_jsx(Toggle, {
            checked: this.state.verboseLoggingEnabled,
            onChange: this.toggleVerboseLogging,
            id: "debug-overlay-verbose-logging"
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: this.sendDebugData,
            use: "secondary",
            size: "small",
            marginBlockEnd: "100",
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.sendData"
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: this.debugClipboardContents,
            use: "secondary",
            size: "small",
            marginBlockEnd: "100",
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-error-reporting.debugOverlay.debugClipboard"
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: this.state.lastEventId ? /*#__PURE__*/_jsx(Text, {
          color: "fill-positive-default",
          as: "span",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-error-reporting.debugOverlay.lastEventMessage",
            options: {
              lastEventId: this.state.lastEventId
            }
          })
        }) : null
      })]
    });
  }
}
DebugOverlay.displayName = 'DebugOverlay';
export default DebugOverlay;